import { createGraphic as createCoreGraphic } from "@visactor/vrender-core/graphic/creator";

const createGraphic = createCoreGraphic;

export const graphicCreator = {
    arc: attributes => createGraphic("arc", attributes),
    circle: attributes => createGraphic("circle", attributes),
    group: attributes => createGraphic("group", attributes),
    image: attributes => createGraphic("image", attributes),
    line: attributes => createGraphic("line", attributes),
    path: attributes => createGraphic("path", attributes),
    polygon: attributes => createGraphic("polygon", attributes),
    rect: attributes => createGraphic("rect", attributes),
    richtext: attributes => createGraphic("richtext", attributes),
    symbol: attributes => createGraphic("symbol", attributes),
    text: attributes => createGraphic("text", attributes)
};
//# sourceMappingURL=graphic-creator.js.map
